import { fetchUtility } from '~/services';
import { FetchUtilityResponse } from '~/services/fetch-utility';
import { store } from '~/utils/store';

export const setUtilitySelection = async (zipCode: string, utilityId: number) => {
  const response = await fetchUtility({ utilityId });
  const utility: FetchUtilityResponse = JSON.parse(JSON.stringify(response));
  store.set('UTILITY_SELECTION', utility);
  store.set('ZIP_CODE', zipCode);
  return utility;
};
